/**
 * Service who provide device informations
 */

import Logger from '../../utils/Logger'
import Service from '../../services/Service'
import DeviceManager from '../manager/DeviceManager'

export default class DeviceService extends Service {

    /**
     * Constructor
     */
    constructor() {
        Logger.log('Device init');
        super();
        /**
         * @type {DeviceManager}
         */
        this.manager = new DeviceManager();
        this.manager.retrievePrivateIpAddress();
    }
}


// WEBPACK FOOTER //
// ./js/core/device/service/DeviceService.js